import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TvScreenService } from '../../services/tv-screen.service';

@Component({
  selector: 'ts-infosystem-hvv',
  templateUrl: './infosystem-hvv.component.html',
  styleUrls: ['./infosystem-hvv.component.css'],
  imports: [NgIf, NgFor],
})
export class InfosystemHvvComponent {
  @Input() stationName: string;
  @Input() schoolId: number;

  departures: any[] = [];

  constructor(private tvScreenSrv: TvScreenService) {
    this.tvScreenSrv.payload$.pipe(takeUntilDestroyed()).subscribe((payload) => {
      this.departures = (payload?.hvv?.departures as unknown[] | undefined) ?? [];
    });
  }

  /** Delay in whole minutes (geofox reports it in seconds). */
  delayMinutes(departure: any): number {
    return Math.round((departure?.delay ?? 0) / 60);
  }

  /**
   * Real-time minutes until departure: the schedule offset plus any live delay.
   * Without this a 3-min-late bus off a schedule 3 min in the past would read
   * "in -3 min (+3)" instead of leaving now.
   */
  realtimeMinutes(departure: any): number {
    return (departure?.timeOffset ?? 0) + this.delayMinutes(departure);
  }
}
